export const siteConfig = {
    appName: 'GAEL LUXURY - Payment Portal',
    metaDescription: 'Secure payment portal',
    faviconUrl: 'https://files.gaeldubai.com/logo.png',
    brandLogoUrl: 'https://files.gaeldubai.com/logo.png',


    brandColors: {
        primary: '#092C46',
        primaryHover: '#072338',
        secondary: '#B4A990',
        buttonText: '#FFFFFF',
    },

    footer: {
        name: 'GAEL LUXURY HOMES RENTAL L.L.C',
        termsOfServiceLabel: 'Terms of Service',
        termsOfServiceUrl: 'https://gaeldubai.com/terms-of-service/',
        privacyPolicyLabel: 'Privacy Policy',
        privacyPolicyUrl: 'https://gaeldubai.com/privacy-policy/',
    },

    paymentSucceededPagePath: '/success',
    setupSucceededPagePath: '/setup-success',
    paymentSucceededPageRedirectLink: '/',
};
